import React, { useEffect, useState } from "react";
import { useStateValue } from "../../../context/store";
import {
  Modal,
  Typography,
  Card,
  CardContent,
  Button,
  Paper,
  TablePagination
} from "@material-ui/core";
import { useForm} from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import FormSearchExamByService from "./formSearchExamByService";
import { getRegionals } from "../../../actions/regional-actions";
import AccordionServicioColectivo from "./accordionServicioColectivo";
import Scrollbars from "react-custom-scrollbars";
import { styleCollective } from "../styleService";
import FormInitialService from "./formInitialService";
import moment from "moment";
import Search from "../../../images/icons/search.svg";
import { getMedicalExam } from "../../../actions/medical-exam-action";
import { getMaestras } from "../../../actions/maestras-actions";
import { saveCollectiveService } from "../../../actions/collective-service-action";
import { downloadPDF } from "../../../utils/functionsUtils";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const ModalServicioColectivo = ({
  message,
  setMessage,
  laboratorys,
  getRequestService
}) => {
  const classes = styleCollective();
  const [modalStyle] = useState(getModalStyle);
  const [{breadCrumb, filterExamByService}, dispatch] = useStateValue();
  const [regional, setRegional] = useState([]);
  const [isContinue, setIsContinue] = useState(false);
  const [stateFirstForm, setStateFirstForm] = useState({});
  const [stateSecondForm, setStateSecondForm] = useState({});
  const [maestras, setMaestras] = useState([]);
  const [checkExam, setCheckExam] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [filterData, setFilterData] = useState({
    from: null,
    to: null,
    document: null,
    regional: null
  })

  const [paginadorRequest, setPaginadorRequest] = useState({
    page: 0,
    size: 10,
    order: "DESC",
    columnOrder: "creationDate",
  });

  const [paginadorResponse, setPaginadorResponse] = useState({
    data: [],
    totalRows: 0,
    pageSize: 0,
    pageNumber: 0,
  })

  const changePage = (event, nuevaPagina) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      page: parseInt(nuevaPagina),
    }));
  };

  const changeAmountOfRecords = (event) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      size: parseInt(event.target.value),
      page: 0,
    }));
  };

  useEffect(() => {
    const getAllRegionals = async () => {
      const response = await getRegionals();
      const sortList = response?.data?.regionalList.sort((a, b) => {
        return a?.name?.localeCompare(b?.name);
      })
      setRegional(sortList);
    }
    getAllRegionals();
  }, [])

  useEffect(() => {
    const getDataMaestras = async () => {
      const resp = await getMaestras();
      setMaestras(resp?.data?.maestras?.tipoOrdenExamenMedico);
    }
    getDataMaestras();
  }, [])

  const schema = yup.object().shape({
    from: yup.date()
    .nullable()
    //.required(REQUIRED_MESSAGE)
    .notRequired()
    .min(
      new Date(1899, 11, 31, 23, 59, 29),
      `Ingrese una fecha superior al año 1900`
    )
    .typeError("Ingrese un formato de fecha válido"),
    to: yup.date()
    .nullable()
    .notRequired()
    //.required(REQUIRED_MESSAGE)
    .min(
      new Date(1899, 11, 31, 23, 59, 29),
      `Ingrese una fecha superior al año 1900`
    )
    .typeError("Ingrese un formato de fecha válido"),
    document: yup.string()
      .nullable()
      .notRequired()
      //.required(REQUIRED_MESSAGE)
      .matches(/^(([0-9])+?)*$/g, 'Ingrese solo números'),
    regional: yup.string()
      .nullable()
      .notRequired()
      //.required(REQUIRED_MESSAGE)
  });
  
  const { register, handleSubmit, errors, control, setValue } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      from: null,
      to: null,
      document: '',
      regional: ''
    },
    mode: "all",
    reValidateMode: "onChange"
  }); 

  const handleClickCloseSuccess = () => {
    setMessage({...message, open: false}); 
    closeMSerColectivo();
    getRequestService();
  };

  const handleClickClose = () => {
    setMessage({...message, open: false});
  }

  const messageRequest = (msg, type, action) => {
    setIsDisabled(false);
    setMessage({
      description : msg,
      textButtonSubmit : 'ACEPTAR',
      handleClick : () => action() ,
      oneButtons : true,
      type : type,
      open : true
    })
  }

  const handleClick = async (data) => {
    setIsDisabled(true);
    setMessage({...message, open:false});
    const result = await saveCollectiveService(data);
    if (result && (result?.status === 200 || result?.status === 201)) {
      const msg = 'Su orden de Servicio colectivo ha sido generada de manera exitosa';
      messageRequest(msg, 'SUCCESS', handleClickCloseSuccess);
      const pdf = result?.data?.documentData;
      downloadPDF(pdf?.data, pdf?.name)
    } else if(result?.status > 399 && result?.status !== 401 && result?.status !== 403){
      const msg = result?.data?.detail
      ? result?.data?.detail
      : 'Ocurrió un error procesando la solicitud, inténtelo nuevamente';
      messageRequest(msg, 'WARNING', handleClickClose);
    } else {
      const msg = 'Ocurrió un error procesando la solicitud, inténtelo nuevamente';
      messageRequest(msg, 'WARNING', handleClickClose);
    }
  }

  const onSubmit = (data) => {
    dispatch({
      type: 'FILTER_EXAM_BYCOLLECTIVE_SERVICE',
      filter: data,
      isFilter: true
    })
    setStateSecondForm(data);
  }

  const getMedicalExamForColService = async () => {
    const filters = {
      initMedicalExamDate: filterData.from ? moment(filterData.from).format("YYYY-MM-DDTHH:mm") : null,
      endMedicalExamDate: filterData.to ? moment(filterData.to).format("YYYY-MM-DDTHH:mm") : null,
      document: filterData.document ? filterData.document : null,
      regionalId: filterData.regional ? filterData.regional : null
    };
    const response = await getMedicalExam(filters, paginadorRequest);
    if(response?.status === 200 || response?.status === 201){
      const newData = response?.data?.medicalExamPage;
      setPaginadorResponse({
        data: newData?.content,
        totalRows: newData?.totalElements,
        pageSize: newData?.size,
        pageNumber: newData?.number,
      })
    }else if(response?.status > 399){
      const textMessage = response?.data?.detail ? response?.data?.detail : response?.data?.error;
      messageRequest(textMessage, 'WARNING', handleClickClose);
    }else{
      setPaginadorResponse({
        data: [],
        totalRows: 0,
        pageSize: 0,
        pageNumber: 0,
      });
    }
  }

  if(filterExamByService && filterExamByService.isFilter && filterData !== filterExamByService.filter){
    const filter = filterExamByService.filter;
    filterData.from = filter.from;
    filterData.to = filter.to;
    filterData.document = filter.document;
    filterData.regional = filter.regional;
    paginadorRequest.page = 0;
    dispatch({
      type: 'FILTER_EXAM_BYCOLLECTIVE_SERVICE',
      isFilter: false
    });
    getMedicalExamForColService();
  }

  useEffect(() => {
    getMedicalExamForColService();
  }, [paginadorRequest])
  
  const handleClickGenerateService = () => {
    if(checkExam?.length === 0){
      const msg = 'Seleccione al menos un examen médico a incluir en la orden de servicio colectivo.'
      messageRequest(msg, 'WARNING', handleClickClose);
      return;
    }
    createObjBySend();
  }

  const createObjBySend = () => {
    const newData = {
      requestDate: moment(stateFirstForm.today).format("YYYY-MM-DDTHH:mm"),
      company: stateFirstForm.company,
      medicalLabId: stateFirstForm.laboratory,
      initDate: stateSecondForm.from ? moment(stateSecondForm.from).format("YYYY-MM-DDTHH:mm") : null,
      endDate: stateSecondForm.to ? moment(stateSecondForm.to).format("YYYY-MM-DDTHH:mm") : null,
      collectiveServiceNumber: stateSecondForm.document ? stateSecondForm.document : null,
      medicalExamIdList: checkExam
    }
    setMessage({
      description : `¿Está seguro que desea guardar la orden de servicio colectivo?`,
      textButtonSubmit : 'Aceptar',
      handleClick : () =>  handleClick(newData),
      handleClickOut: () => handleClickClose(),
      type : 'QUESTION',
      open : true
    })
  }
  
  const closeMSerColectivo = () => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Consultar orden de servicio colectivo",
      breadCrumbSubText: "Consultar orden de servicio colectivo",
      index: 25,
      open: false,
      isCollectiveService: true,
    });
    cleanForm();
    setIsContinue(false);
  }

  const cleanContext = () => {
    dispatch({
      type: 'FILTER_EXAM_BYCOLLECTIVE_SERVICE',
      filter: {
        from: null,
        to: null,
        document: null,
        regional: null
      },
      isFilter: true
    });
    setCheckExam([]);
  }

  const cleanForm = () => {
    cleanContext();
    setValue('from', null);
    setValue('to', null);
    setValue('document', '');
    setValue('regional', '');
  }

  const onSubmitNextForm = (info) => {
    setStateFirstForm(info)
    setIsContinue(true);
  }

  const handleChangeCheckedService = (e, id) => {
    if(e.target.checked){
      setCheckExam([...checkExam, e.target.value]);
    }else{
      const newList = checkExam?.filter(x => x !== e.target.value);
      setCheckExam(newList);
      isSelectedCheck(id)
    }
  }

  const isSelectedCheck = (id) => {
    const selected = checkExam?.find(x => x === id) ?? false;
    return (selected);
  }

  const bodyModal = (
    <div style={modalStyle} className={classes.cardSerColectivo}>
      <Card className={classes.card} elevation={0} >
      <CardContent>
        <Typography className={classes.title}>
          Orden de servicio colectivo
        </Typography>

        {!isContinue &&
          <FormInitialService 
            laboratorys={laboratorys}
            onSubmitNextForm={onSubmitNextForm}
            handleClickGoBack={closeMSerColectivo}
          />
        }

        {isContinue && <>
          <FormSearchExamByService
            register={register}
            control={control}
            handleSubmit={handleSubmit}
            errors={errors}
            cleanForm={cleanForm}
            onSubmit={onSubmit}
            regional={regional}
          />
        
        <div className={classes.contAccordion}>
          <Paper elevation={0} className={classes.paperdos}>
            <Scrollbars className={classes.Scrollbars}>
              {
                paginadorResponse?.data?.length > 0
                  ?  paginadorResponse?.data?.map((resp, index) => (
                      <AccordionServicioColectivo 
                        key={index}
                        data={resp}
                        maestras={maestras}
                        handleChangeCheckedService={handleChangeCheckedService}
                        isSelectedCheck={isSelectedCheck}
                      />
                    ))
                  : null
              }

              {paginadorResponse?.totalRows !== 0 ? (
                <TablePagination
                  style={{ display: "flex", justifyContent: "center" }}
                  rowsPerPageOptions={[5, 10, 15]}
                  count={paginadorResponse.totalRows}
                  rowsPerPage={paginadorRequest.size}
                  page={paginadorRequest.page}
                  labelRowsPerPage="Registros por página"
                  onChangePage={changePage}
                  onChangeRowsPerPage={changeAmountOfRecords}
                />
                ) : (
                  <React.Fragment>
                    <div className={classes.messageSearch}>
                      <img src={Search} alt="" />
                      <Typography style={{ paddingTop: "20px", paddingLeft: "20px" }}>
                        No se encontraron registros que coincidan con el filtro de
                        búsqueda aplicado
                      </Typography>
                    </div>
                  </React.Fragment>
                )
              }
            </Scrollbars>
          </Paper>
        </div>

        <div className={classes.contBtnSubmit}>
          <Button
            variant='outlined'
            style={{backgroundColor: 'transparent', color: '#7EBDCE'}}
            onClick={closeMSerColectivo}
            >
            Cancelar
          </Button>
            &nbsp;&nbsp;
          {paginadorResponse?.totalRows !== 0
            ? <Button 
                variant='outlined' 
                onClick={handleClickGenerateService}
                style = {{backgroundColor: '#7EBDCE', border: 'none', color: '#ffffff',}}
                disabled={isDisabled}
              > 
                Guardar
              </Button >
            : null
          }
        </div>
        </>}

     </CardContent>
    </Card>
    </div>
  );

  return (
    <div>
      <Modal
        style={{ textAlign: "center" }}
        open={breadCrumb?.open}
      >
        {bodyModal}
      </Modal>
    </div>
  );
};

export default ModalServicioColectivo;
